module.exports = require('./helpers/bundle-url').getBundleURL('dgt5F') + "resume_fall2024.2350a0e2.pdf";